module.exports = __webpack_public_path__ + "img/4-Editor-Adding-Transition.b5bb1beb.gif";